<div class="mobile-menu">
  @if (isOpen()) {
    <cov-icon [iconName]="iconName.CLOSE"></cov-icon>
    <cov-sidebar-navigation
      class="navigation"
      [multi]="false"
      [expanded]="true"
      (navigation)="close()"
    />
  } @else {
    <cov-icon [iconName]="iconName.BARS"></cov-icon>
  }
</div>
